import { render, staticRenderFns } from "./message_center.vue?vue&type=template&id=820d5490&"
import script from "./message_center.vue?vue&type=script&lang=js&"
export * from "./message_center.vue?vue&type=script&lang=js&"
import style0 from "./message_center.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports